import { render, staticRenderFns } from "./SelectRegionList.vue?vue&type=template&id=81f8d85a&"
import script from "./SelectRegionList.vue?vue&type=script&lang=js&"
export * from "./SelectRegionList.vue?vue&type=script&lang=js&"
import style0 from "./SelectRegionList.vue?vue&type=style&index=0&id=81f8d85a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports